/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useEffect } from "react";
import { useAppDirektdruckContext } from "../AppDirektdruckContext";
import IAppDirektdruckContext from "../AppDirektdruckContext/IAppDirektdruckContext";

export default class AppDirektdruckModel {
    private readonly _appDirektdruckContext: IAppDirektdruckContext;

    public constructor() {
        this._appDirektdruckContext = useAppDirektdruckContext();

        const url = this._appDirektdruckContext.url;
        const update = this._appDirektdruckContext.update;
        useEffect(() => {
            const url = this._appDirektdruckContext.url;
            if (url !== this.defaultSrc) {
                this.drucken(url);
            }
        }, [url, update]);
    }

    public get printFrameName() {
        return "lan-appdirektdruck__iframe";
    }

    public get defaultSrc() {
        return "";
    }

    private readonly drucken = (url: string) => {
        const _printFrame = document.getElementById(this.printFrameName) as HTMLIFrameElement;
        _printFrame.onload = () => {
            const pdfWindow = _printFrame.contentWindow;
            if (pdfWindow !== null) {
                pdfWindow.print();
            }
        };

        _printFrame.src = url;
    };
}
